import React__default, { useState } from 'react';
import { u as useChannelListContext } from '../../chunks/bundle-DaPdVbQX.js';
import { A as AddGroupChannelView } from '../../chunks/bundle-CBHlCwa8.js';
import '../../chunks/bundle-CxLxJCBu.js';
import '@sendbird/chat/groupChannel';
import '../../chunks/bundle-mqagBpi9.js';
import '../../chunks/bundle-DKdROCX_.js';
import '../../chunks/bundle-kFa80LJe.js';
import '../../chunks/bundle-DP3z2QNm.js';
import '../../chunks/bundle-DXFVroy5.js';
import '@sendbird/uikit-tools';
import '../../withSendbird.js';
import '../../chunks/bundle-DRpjMk0B.js';
import '../../chunks/bundle-BA9oFJ90.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DiK8ifY3.js';
import '../../chunks/bundle-C-nZYnmy.js';
import 'react-dom';
import '../../chunks/bundle-d1cOX5nv.js';
import '../../chunks/bundle-DS1EhNtb.js';
import '../../chunks/bundle-Ci-RNuvu.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-CjJk57u5.js';
import '../../ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-DdJ9pMWn.js';
import '../../useSendbirdStateContext.js';
import '../../chunks/bundle-BzR1dD25.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-D2HQ66dZ.js';
import '../../CreateChannel.js';
import '../../CreateChannel/components/CreateChannelUI.js';
import '../../chunks/bundle-CYoJWHCE.js';
import '../../sendbirdSelectors.js';
import '../../CreateChannel/components/InviteUsers.js';
import '../../ui/UserListItem.js';
import '../../chunks/bundle-DOfhjbKd.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_zEpfCP.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../CreateChannel/components/SelectChannelType.js';

var AddChannel = function () {
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    var _b = useChannelListContext(), overrideInviteUser = _b.overrideInviteUser, onBeforeCreateChannel = _b.onBeforeCreateChannel, onChannelSelect = _b.onChannelSelect;
    return (React__default.createElement(AddGroupChannelView, { createChannelVisible: showModal, onChangeCreateChannelVisible: setShowModal, onCreateChannelClick: overrideInviteUser, onBeforeCreateChannel: onBeforeCreateChannel, onChannelCreated: function (it) { return onChannelSelect === null || onChannelSelect === void 0 ? void 0 : onChannelSelect(it); } }));
};

export { AddChannel, AddChannel as default };
//# sourceMappingURL=AddChannel.js.map
